import type { FaireRetailerEntity } from "../../entity_types/retailer";

export const r_31m33roqxk: FaireRetailerEntity = {
  token: "r_31m33roqxk",
  type: "retailer",
  name: "Shiva's Gift Shop",
  city: "Washington",
  state: "DC",
  country: "US",
  themeTokens: [
    "crystal-sanctuary-and-healing",
    "boho-chic-boutique-styles",
    "premium-counter-side-cravings",
    "zen-and-spiritual-sanctuary",
    "mindful-and-vegan-indulgences",
    "mindful-sips-and-spirits",
    "whimsical-gemstone-wonders",
    "whimsical-home-accents",
    "spiritual-pocket-accents",
    "gourmet-confectionery-corner",
    "elemental-flow-and-vitality",
    "empowered-california-crystals",
    "the-gift-shop-snack-corner",
    "global-curiosity-cravings",
    "spiritual-garden-sanctuary",
    "grab-and-go-refreshments",
    "vibrant-tropical-refreshments",
    "southwest-road-trip-vibes",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-03-26T00:00:00Z",
    importedBy: "manual-v3-import",
  },
};
